var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"px-md-0"},[_c('p',{staticClass:"signature text-right small m-0 pb-5 pt-3",domProps:{"innerHTML":_vm._s(_vm.$t('hos.credits', _vm.$t('hos.data.credits')))}})]),_vm._v(" "),_c('section',{attrs:{"id":"outro","role":"presentation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }